import type { AssignedState } from "../../../components/AssignedStateToggle";

export type FormatCategory = "pdf" | "image";

export type { AssignedState };

export type Filters = {
  invoice: AssignedState;
  transaction: AssignedState;
  formats: FormatCategory[];
  namePattern: string;
  from: string | null;
  to: string | null;
};

export const defaultFilters: Filters = {
  invoice: "any",
  transaction: "any",
  formats: [],
  namePattern: "",
  from: null,
  to: null,
};

export const isDefaultFilters = (f: Filters): boolean =>
  f.invoice === "any" &&
  f.transaction === "any" &&
  f.formats.length === 0 &&
  f.namePattern === "" &&
  f.from === null &&
  f.to === null;
